import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { WhatsappNumber } from '@core/models/whatsapp-number.model';
import { Pagination } from '@core/models/pagination.model';

@Injectable()
export class WhatsappNumberDataService extends DefaultDataService<WhatsappNumber> {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('WhatsappNumber', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<WhatsappNumber[]> {
    return this.http.get<ApiResponse>('/whatsappnumber').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  add(whatsappNumber?: WhatsappNumber): Observable<WhatsappNumber>{
    return this.http.post<ApiResponse>(`/whatsappnumber`, whatsappNumber).pipe(
      tap( res => this.messages$.next(res.message)),
      concatMap((entity) => this.http.get(`/whatsappnumber/${entity.data.rows.id}`).pipe(
        map((row: ApiResponse) => row.data.rows)
      ))
    );
  }

  getWithQuery(pageParam: string): Observable<WhatsappNumber[]>{
    return this.http.get<ApiResponse>(`/whatsappnumber${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    )
  }

  getById(id: number): Observable<WhatsappNumber>{
    return this.http.get<ApiResponse>(`/whatsappnumber/${id}`).pipe(
      map(res => res.data.rows)
    );
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }

}
